var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { attrs: { cols: "6" } },
        [
          _c(
            "v-card",
            {
              staticClass: "rounded v-application",
              attrs: { outlined: "", elevation: "0" },
            },
            [
              _c(
                "v-card-title",
                { staticClass: "d-flex justify-space-between" },
                [
                  _c("span", [_vm._v("Kontakt")]),
                  _vm._v(" "),
                  _c("add-pharmacy-source", {
                    attrs: { pharmacy_id: _vm.pharmacy._id },
                    on: {
                      "get-pharmacy": function ($event) {
                        return _vm.$emit("get-pharmacy")
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", { attrs: { cols: "auto" } }, [
                        _c(
                          "a",
                          {
                            attrs: { href: `tel:${_vm.pharmacy.phone}` },
                            on: { click: _vm.addCallHistory },
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "mb-1",
                                attrs: { size: "14", color: "primary" },
                              },
                              [
                                _vm._v(
                                  "\n                                mdi-phone-classic\n                            "
                                ),
                              ]
                            ),
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.pharmacy.phone) +
                                "\n                        "
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.pharmacy.mobile
                        ? _c("v-col", { attrs: { cols: "auto" } }, [
                            _c(
                              "a",
                              {
                                attrs: { href: `tel:${_vm.pharmacy.mobile}` },
                                on: { click: _vm.addCallHistory },
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { size: "14", color: "primary" } },
                                  [_vm._v("mdi-phone")]
                                ),
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.pharmacy.mobile) +
                                    "\n                        "
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.whatsappMobileLink
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "ml-1",
                                    attrs: {
                                      href: _vm.whatsappMobileLink,
                                      target: "_blank",
                                      rel: "noopener",
                                      title: "Chat via WhatsApp",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: { size: "18", color: "success" },
                                      },
                                      [_vm._v("mdi-whatsapp")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.pharmacy.fax
                        ? _c(
                            "v-col",
                            { attrs: { cols: "auto" } },
                            [
                              _c("v-icon", { attrs: { size: "14" } }, [
                                _vm._v("mdi-fax"),
                              ]),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.pharmacy.fax) +
                                  "\n                    "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-col", { attrs: { cols: "auto" } }, [
                        _c(
                          "a",
                          { attrs: { href: `mailto:${_vm.pharmacy.email}` } },
                          [
                            _c(
                              "v-icon",
                              { attrs: { size: "14", color: "primary" } },
                              [_vm._v("mdi-email")]
                            ),
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.pharmacy.email) +
                                "\n                        "
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.pharmacy.email_alt
                        ? _c("v-col", { attrs: { cols: "auto" } }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: `mailto:${_vm.pharmacy.email_alt}`,
                                },
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { size: "14", color: "primary" } },
                                  [_vm._v("mdi-email")]
                                ),
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.pharmacy.email_alt) +
                                    "\n                        "
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.pharmacy.email_billing
                        ? _c("v-col", { attrs: { cols: "auto" } }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: `mailto:${_vm.pharmacy.email_billing}`,
                                },
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { size: "14", color: "primary" } },
                                  [_vm._v("mdi-email")]
                                ),
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.pharmacy.email_billing) +
                                    "\n                        "
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.pharmacy.website
                        ? _c("v-col", { attrs: { cols: "auto" } }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: `${_vm.pharmacy.website}`,
                                  target: "_blank",
                                },
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { size: "14", color: "primary" } },
                                  [_vm._v("mdi-web")]
                                ),
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.pharmacy.website) +
                                    "\n                        "
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.pharmacy.sources?.length
                        ? _c(
                            "v-col",
                            {
                              staticClass: "d-flex align-baseline",
                              attrs: { cols: "auto" },
                            },
                            [
                              _c("v-icon", { attrs: { size: "14" } }, [
                                _vm._v("mdi-database"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "sources pl-1" },
                                _vm._l(_vm.pharmacy.sources, function (source) {
                                  return _c("li", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(source.name) +
                                        "\n                            "
                                    ),
                                  ])
                                }),
                                0
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.pharmacy.accommodation
                        ? _c(
                            "v-col",
                            { attrs: { cols: "auto" } },
                            [
                              _c("v-icon", { attrs: { size: "14" } }, [
                                _vm._v("mdi-power-sleep"),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.pharmacy.pretty_accommodation)
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.pharmacy.accommodation == "4"
                                ? _c("span", [
                                    _vm.pharmacy.accommodation_fee
                                      ? _c("span", [
                                          _vm._v(
                                            ": " +
                                              _vm._s(
                                                _vm.$n(
                                                  _vm.pharmacy
                                                    .accommodation_fee,
                                                  "currency",
                                                  "de-DE"
                                                )
                                              )
                                          ),
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            ": Bitte den Pauschalbetrag mit der Apotheke besprechen und eintragen."
                                          ),
                                        ]),
                                  ])
                                : _vm.pharmacy.accommodation == "3" &&
                                  _vm.pharmacy.accommodation_name
                                ? _c("div", [
                                    _vm._v(
                                      "\n                            '" +
                                        _vm._s(
                                          _vm.pharmacy.accommodation_name
                                        ) +
                                        "'\n                        "
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.pharmacy.erp
                        ? _c(
                            "v-col",
                            { attrs: { cols: "auto" } },
                            [
                              _c("v-icon", { attrs: { size: "14" } }, [
                                _vm._v("mdi-briefcase-outline"),
                              ]),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.pharmacy.erp) +
                                  "\n                    "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c("v-icon", { attrs: { size: "14" } }, [
                            _vm._v("mdi-currency-eur"),
                          ]),
                          _vm._v(" "),
                          _vm.pharmacy.max_travel_cost
                            ? _c("span", [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$n(
                                        _vm.pharmacy.max_travel_cost,
                                        "currency",
                                        "de-DE"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ])
                            : _c("span", [_vm._v("80 € (Standardwert)")]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-col", { attrs: { cols: "auto" } }, [
                        _c("ul", [
                          _c("li", [
                            _c("span", { staticClass: "font-weight-medium" }, [
                              _vm._v("Wie häufig besteht Personalbedarf?"),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "ml-1" }, [
                              _vm._v(_vm._s(_vm.pharmacy.lead_need_frequency)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", { staticClass: "font-weight-medium" }, [
                              _vm._v("Warum suchen Sie Unterstützung?"),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "ml-1" }, [
                              _vm._v(_vm._s(_vm.pharmacy.lead_need_reason)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("span", { staticClass: "font-weight-medium" }, [
                              _vm._v(
                                "Wie sind Sie auf uns aufmerksam geworden?"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "ml-1" }, [
                              _vm._v(_vm._s(_vm.pharmacy.lead_referral_source)),
                            ]),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-col",
        { attrs: { cols: "3" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded", attrs: { outlined: "", elevation: "0" } },
            [
              _c("v-card-title", [_vm._v("Kommentare")]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _vm.pharmacy.comment
                    ? _c(
                        "v-row",
                        { staticClass: "v-application" },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pr-0", attrs: { cols: "auto" } },
                            [_c("b", [_vm._v("Kommentar:")])]
                          ),
                          _vm._v(" "),
                          _c("v-col", [
                            _c("span", {
                              staticClass: "textarea-comment",
                              domProps: {
                                innerHTML: _vm._s(_vm.pharmacy.comment),
                              },
                            }),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.pharmacy.ma_comment
                    ? _c(
                        "v-row",
                        { staticClass: "v-application" },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pr-0", attrs: { cols: "auto" } },
                            [_c("b", [_vm._v("Anmerkung f. Freiberufler:")])]
                          ),
                          _vm._v(" "),
                          _c("v-col", [
                            _c("span", {
                              staticClass: "textarea-comment",
                              domProps: {
                                innerHTML: _vm._s(_vm.pharmacy.ma_comment),
                              },
                            }),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mt-0" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "d-flex justify-space-around" },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                dark: "",
                                fab: "",
                                width: "35",
                                height: "35",
                                color: "pink lighten-2",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openMoreInfoDialog(
                                    "organizational"
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { size: "20", dark: "" } },
                                [_vm._v("mdi-account-group")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "open-location-dialog",
                              attrs: {
                                dark: "",
                                fab: "",
                                width: "35",
                                height: "35",
                                color: "primary lighten-1",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openMoreInfoDialog("location")
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { size: "20", dark: "" } },
                                [_vm._v("mdi-map-marker")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-dialog",
                    {
                      attrs: { "max-width": "530px" },
                      model: {
                        value: _vm.isDialogOpen,
                        callback: function ($$v) {
                          _vm.isDialogOpen = $$v
                        },
                        expression: "isDialogOpen",
                      },
                    },
                    [
                      _c(_vm.componentToOpen, {
                        tag: "component",
                        attrs: { pharmacy: _vm.pharmacy },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-col",
        { attrs: { cols: "3" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded", attrs: { outlined: "", elevation: "0" } },
            [
              _c("v-card-title", [_vm._v("Freiberufler")]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "fb-list" },
                [
                  _c(
                    "v-list",
                    { staticClass: "py-0" },
                    _vm._l(_vm.knownPharmacists, function (pharmacist, idx) {
                      return _c(
                        "div",
                        { key: pharmacist.id },
                        [
                          _c(
                            "v-list-item",
                            [
                              _c(
                                "v-list-item-content",
                                { staticClass: "overflow-visible" },
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "mr-3" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: `/pharmacists/${pharmacist._id}`,
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(pharmacist.name) +
                                              "\n                                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("preference-chip", {
                                    attrs: {
                                      favorite: pharmacist.favorite,
                                      blacklisted: pharmacist.blacklisted,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          idx + 1 < _vm.knownPharmacists.length
                            ? _c("v-divider")
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }